<template>
  <div>
    <div class="form-steps-outer">
      <div class="backer clearfix">
        <div class="col-xs-12 col-md-3" v-for="(field, i) in fields">
          <label :for="'profile-' + field.label" class="form-label"><span class="badge">{{ i + 1 }}</span> {{ field.label }}</label>
          <div class="input-group">
            <input disabled type="text" class="form-control" :id="'profile-' + field.label" :value="display[field.vModel]"/>
            <span class="input-group-addon" @click="searchProfiles(field.profileCode, field.vModel)">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
        <div class="col-xs-12 col-md-3">
          <div :class="[ valid ? '' : 'disabled', 'btn btn-primary sq fw-merge' ]" @click="merge">
            Merge
          </div>
        </div>
      </div>
    </div>
    <div class="merge-selector">
      <blockquote>Select Merge Type</blockquote>
      <div class="form-group">
        <select class="form-control" v-model="mergeType">
          <option value="fcl">Ocean FCL</option>
          <option value="lcl">Ocean LCL</option>
          <option value="auto">Ocean Auto</option>
          <option value="air">Air</option>
        </select>
      </div>
    </div>
    <div class="merge-stats clearfix">
      <div class="shadow clearfix pad-15">
        <hr class="hr-text" data-content="Your Tariff Overview">
        <vue-table
          v-on:table-delete-request="deleteEntity"
          v-on:table-edit-request="handleEdit"
          :showEdit="true"
          :showDelete="true"
          :tableData="tableData"
          tableTitle="Recently Merged Tariffs"
          :fields="[
          { header: 'Name', prop: 'name' },
          { header: 'Type', prop: item => item.lookupType !== null ? item.lookupType.name : '' },
          { header: 'Agent', prop: item => item.owner ? item.owner.name : '' }
          ]"
        ></vue-table>
        <info-widget
          :stats="{ title: 'Profiles', stat: stats.profiles }"
          backgroundColor="#00beee"
          color="#fff"
          animate
          logo="fa fa-globe"
          class="col-xs-12 col-sm-6 wid">
        </info-widget>
        <info-widget
          :stats="{ title: 'Tariffs', stat: stats.tariffs }"
          backgroundColor="#02a85c"
          logo="fa fa-map-marker"
          color="#fff"
          animate
          class="col-xs-12 col-sm-6 wid">
        </info-widget>
        <info-widget
          :stats="{ title: 'Lines', stat: stats.lines }"
          backgroundColor="#f39c11"
          logo="fa fa-industry"
          color="#fff"
          animate
          class="col-xs-12 col-sm-6 wid">
        </info-widget>
        <info-widget
          :stats="{ title: 'Accessorials', stat: stats.accessorials }"
          backgroundColor="#f56854"
          logo="fa fa-user"
          color="#fff"
          animate
          class="col-xs-12 col-sm-6 wid">
        </info-widget>
      </div>
    </div>
  </div>
</template>
<script>
  import event from '../../../event'
  import HelperMixin from '../../admin/mixins/Helpers'
  import ResultsMixin from '../../admin/mixins/AdminSearchResultsMixin'
  import API from '../../../api/endpoints'
  import InfoWidget from '../../helpers/InfoWidget'
  import VueTable from '../../helpers/VueTable'
  export default {
    name: 'TariffMerge',
    mixins: [ HelperMixin, ResultsMixin ],
    components: {
      InfoWidget,
      VueTable
    },
    data () {
      return {
        mergeType: 'fcl',
        event: 'tariff-merge-filtered',
        editEntityScreen: 'Admin - Edit/View Tariff',
        entityName: 'lookup',
        fields: [
          {
            label: 'Precarriage Profile',
            vModel: 'preCarriage',
            profileCode: 'PC'
          },
          {
            label: 'Ocean Freight Profile',
            vModel: 'oceanFreight',
            profileCode: 'OF'
          },
          {
            label: 'Oncarriage Profile',
            vModel: 'onCarriage',
            profileCode: 'OC'
          }
        ],
        search: {
          preCarriage: null,
          oceanFreight: null,
          onCarriage: null
        },
        stats: {
          profiles: 0,
          tariffs: 0,
          lines: 0,
          accessorials: 0
        },
        tableData: []
      }
    },
    watch: {
      mergeType (n, o) {
        if (n !== o) {
          this.reset()
        }
      }
    },
    methods: {
      getResults () {
        /* noOp */
      },
      reset () {
        for (let prop in this.search) {
          this.search[prop] = null
          event.$emit('right-close')
        }
      },
      searchProfiles (code, prop) {
        let profileCode = this.getCode(prop)
        let lookupProfileType = this.getProfileTypeIdFromCode(profileCode)
        if (lookupProfileType) {
          event.$emit('right-open', { callerId: this._uid, component: 'tariff-merge-filter', data: { lookupProfileType, prop }, event: this.event })
        } else {
          event.$emit('toast', { type: 'warning', message: `Lookup Profile Type with code ${code} not found` })
        }
      },
      getCode (carriageCode) {
        let obj = {
          fcl: {
            preCarriage: 'PC',
            oceanFreight: 'FR',
            onCarriage: 'OC'
          },
          lcl: {
            preCarriage: 'FRLPC',
            oceanFreight: 'FRL',
            onCarriage: 'FRLOC'
          },
          air: {
            preCarriage: 'AIRPC',
            oceanFreight: 'AIR',
            onCarriage: 'AIROC'
          },
          auto: {
            preCarriage: 'APC',
            oceanFreight: 'AUTO',
            onCarriage: 'AOC'
          }
        }
        return obj[this.mergeType][carriageCode]
      },
      getProfileTypeIdFromCode (find) {
        let profile = this.lookupProfileTypes.find(({code}) => code === find)
        return profile ? profile.id : null
      },
      update ({ prop, selection }) {
        this.search[prop] = selection
      },
      makeDisplay (val) {
        return val !== null && val.hasOwnProperty('id') ? `${val.description}, ${val.serviceProvider.name} - ${val.serviceProvider.code}, ${val.lookupProfileType.name}` : ''
      },
      getStats () {
        let defaults = [
          { prop: 'profiles', entity: 'lookup-profile' },
          { prop: 'tariffs', entity: 'lookup' },
          { prop: 'lines', entity: 'lookup-detail' },
          { prop: 'accessorials', entity: 'lookup-addition' }
        ]
        defaults.forEach(this.getCount)
      },
      getCount ({ prop, entity }) {
        this.$http.get(API.GET_STATS_COUNT(entity))
        .then(({data}) => {
          this.stats[prop] = data.value
        }).catch(err => console.log(err))
      },
      merge () {
        if (this.valid) {
          event.$emit('loading-on', { title: 'Merging' })
          this.$http.post(API.DO_MERGE, this.requestBody)
          .then(({data}) => {
            this.getStats()
            event.$emit('toast', { type: 'success', message: `A total of ${data.tariffs.length} tariffs were created` })
            this.tableData.push(...data.tariffs)
          })
          .catch(err => {
            event.$emit('toast', { type: 'error', message: `An error occured during merge - please ensure the profile types and their tariffs match` })
            console.log(err)
          }).then(() => {
            event.$emit('loading-off')
          })
        } else {
          event.$emit('toast', { type: 'warning', message: `Ensure you have profiles selected` })
        }
      }
    },
    computed: {
      requestBody () {
        return this.valid ? { onCarriage: this.search.onCarriage.id, oceanFreight: this.search.oceanFreight.id, preCarriage: this.search.preCarriage.id }
          : {}
      },
      validProfileTypes () {
        let codes = ['FR', 'PC', 'OC', 'FRL', 'FRLPC', 'FRLOC', 'AIR', 'AIRPC', 'AIROC', 'AUTO', 'APC', 'AOC']
        return this.lookupProfileTypes.filter(({code}) => codes.includes(code))
      },
      valid () {
        return this.search.preCarriage !== null && this.search.preCarriage.hasOwnProperty('id') &&
               this.search.onCarriage !== null && this.search.onCarriage.hasOwnProperty('id') &&
               this.search.oceanFreight !== null && this.search.oceanFreight.hasOwnProperty('id')
      },
      lookupProfileTypes () {
        return this.sortedOptions('LOOKUP_PROFILE_TYPE')
      },
      display () {
        return {
          preCarriage: this.makeDisplay(this.search.preCarriage),
          oceanFreight: this.makeDisplay(this.search.oceanFreight),
          onCarriage: this.makeDisplay(this.search.onCarriage)
        }
      }
    },
    mounted () {
      event.$on(this.event, this.update)
      this.getStats()
    },
    beforeDestroy () {
      event.$off(this.event, this.update)
    }
  }
</script>
<style>
  .fw-merge {
    width: 100%;
    margin-top: 24px;
    padding: 12px;
  }
  .merge-stats {
    padding: 0 10px;
  }
  .merge-stats .wid {
    margin-top: 10px;
  }
  .pad-15 {
    padding: 15px !important;
  }
  .merge-selector {
    padding: 10px;
  }
  .merge-selector * {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// TariffMerge.vue?41bfd4d4